// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "-" + {"149":"8904b232db3e87c47609","710":"ec0e7bd03004a8b2d65a"}[chunkId] + ".js";
};